"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfessionalExperience = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const contact_entity_1 = require("./contact.entity");
let ProfessionalExperience = class ProfessionalExperience {
    constructor(createdAt, updatedAt, createdBy, updatedBy, contact) {
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.contact = contact;
    }
};
exports.ProfessionalExperience = ProfessionalExperience;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], ProfessionalExperience.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "from_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], ProfessionalExperience.prototype, "fromDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "to_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], ProfessionalExperience.prototype, "toDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], ProfessionalExperience.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "designation", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], ProfessionalExperience.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "department", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], ProfessionalExperience.prototype, "department", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "details", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], ProfessionalExperience.prototype, "details", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], ProfessionalExperience.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], ProfessionalExperience.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], ProfessionalExperience.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ProfessionalExperience.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ProfessionalExperience.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.professionalExperiences, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], ProfessionalExperience.prototype, "contact", void 0);
exports.ProfessionalExperience = ProfessionalExperience = tslib_1.__decorate([
    (0, typeorm_1.Entity)("professional_experience"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, Number, Object])
], ProfessionalExperience);
